/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/12/2020
 */
import BaseObject from "@shared/BaseObject.js";
import QwoachDataManager from "@/core/js/backend/QwoachDataManager";
import Migration from "@/utils/dataMigration/Migration";
import AuthManager from "@/core/js/backend/AuthManager";
import {logError} from "@/utils/helpers";

export default class BaseMigrationManager extends BaseObject {

	dataManager: QwoachDataManager
	authManager: AuthManager
	analyticManager
	migrations: Migration[] = []


	constructor(dataManager: QwoachDataManager, authManager: AuthManager, analyticManager) {
		super();
		this.dataManager = dataManager;
		this.authManager = authManager
		this.analyticManager = analyticManager
	}

	addMigration(migration){
		this.migrations.push(migration)
		return this
	}

	async needsUpgrade(){
		throw new Error("needsUpgrade not implemented")
	}

	async startUpgrade(startVersion, endVersion, progressCallback = (currentMigration, numberOfMigrations) => {}){
		console.log("DatabaseMigrationManager.startUpgrade: startVersion = ", startVersion, ", endVersion = ", endVersion)

		this.migrations.sort((l, r) => l.startVersion - r.startVersion)

		let isMigrationEligible = (migration) => migration.startVersion >= startVersion && migration.endVersion <= endVersion
		let numberOfMigrations = this.migrations.filter(isMigrationEligible).length
		let currentMigration = 0

		for(let migration of this.migrations){
			progressCallback(currentMigration, numberOfMigrations)
			if(isMigrationEligible(migration)){
				console.log("DatabaseMigrationManager.startUpgrade: migrate from ", migration.startVersion, " to ", migration.endVersion)
				await migration.migrate(this.dataManager, this.authManager)
				//we don't await the log since it may hang the migration process if certain browser extensions are installed like adblockers, especially in firefox.
				let _ = this.tryLogMigration({startVersion: migration.startVersion, endVersion: migration.endVersion})
				currentMigration++
			}
		}
		progressCallback(currentMigration, numberOfMigrations)

		console.log("DatabaseMigrationManager.startUpgrade: migration completed")
	}

	async tryLogMigration({startVersion, endVersion}){
		try{
			this.analyticManager.trackEvent("Version updated", {startVersion, endVersion})
		} catch (e) {
			let _ = logError(e)
		}
	}

}
